import { Midi } from "@tonejs/midi";
import createnotes from "./game/createnotes";
import initengine from "./game/initengine";
import InputManager from "/src/js/engine/inputManager";
import Player from "./game/entities/player";
import Boss from "./game/entities/boss";
import MusicManager from "./game/entities/musicmanager";
import { gsap } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin';
import scoreSFXURL from "url:/src/sounds/coin.wav";

import Loader from "./loader";

const midi_url = require("url:../midi/acdc-midi-file.mid");
const audio_url = require("url:../sounds/acdc.mp3");

window.addEventListener("load", function () {
  gsap.registerPlugin(CSSPlugin);

  gsap.set(".hud", { autoAlpha: 0 });

  loadScoreboard();

  const loader = new Loader();
  setTimeout(() => loader.load(), 300);

  const engine = initengine();
  const inputs = new InputManager();

  let started = false;
  document.getElementById("game-start").addEventListener("click", (e) => {
    if (started) return;
    started = true;

    const music = new MusicManager({
      engine, tracklist: [
        {
          name: "acdc",
          url: audio_url,
        }
      ]
    });

    let tl = gsap.timeline();
    tl.to(".darkmoon", { duration: .5, x: 300 }, 0)
    tl.to(".guitar-stand", { duration: 1, x: -300 }, 0)
    tl.to(".tutorial", { duration: .5, autoAlpha: 0 }, 0)
    tl.fromTo(".hud", { duration: .5, autoAlpha: 0, y: -10 }, { duration: .5, autoAlpha: 1, y: 0 }, 0);

    const counter = document.querySelector(".start-counter");

    ["3", "2", "1", "FIGHT"].forEach((text, i) => {
      tl.fromTo(counter, { duration: 1, scale: 0.5, autoAlpha: 0 }, {
        duration: .5, scale: 1, autoAlpha: 1, onStart: () => {
          counter.textContent = text;
          const sfx = new Audio(scoreSFXURL);
          sfx.volume = 0.1;
          sfx.play();
        }
      });
      tl.to(counter, { autoAlpha: 0, scale: i == 3 ? 2 : 1, duration: .1, delay: 0.4 });
    })


    tl.add(() => startGame(engine, music, inputs), 4);
  });
  engine.start();
});

function startGame(engine, music, inputs) {
  Midi.fromUrl(midi_url).then((midi) => {
    createnotes({ engine, midi, delay: 0, playsound: false });
    setTimeout(() => music.audioPlayer.start(), 0);
    const player = new Player({ engine, inputs, music });
    const boss = new Boss({ engine, music, player });
    gsap.to(boss, { duration: 3, offset: 0 });
    gsap.from(player, { duration: 5, smoothing: 0 });
  });
}

async function loadScoreboard() {
  //const response = await fetch('https://creano.paris/xxxx/ranking', {
  const response = await fetch('/api/ranking', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })

  if (!response.ok) {
    console.error('Erreur lors du chargement du scoreboard');
    return;
  }

  const data = await response.json();
  const userList = document.querySelector('.userList');

  data.forEach((user, index) => {
    const userDiv = document.createElement('div');
    userDiv.classList.add('user');
    userDiv.innerHTML = `
    <span>#${index + 1}</span>
    <span class="username">${user.username}</span>
    <span class="score">${user.score}</span>
  `;
    userList.appendChild(userDiv);
  });
}